/*=========================================================================================
  File Name: module-import-state.js
  Description: Supplier Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	ImportColumns: [],
	ImportColumnsNoDownloadInvoice: [],
	Lang: 'vi'
};
